// extracted by mini-css-extract-plugin
export default {"additional_item":"rA","info_wrapper":"sA","addition_item_img_wrapper":"tA","title":"uA","quantity":"vA","flavors":"wA","old_price":"xA","discount":"yA","button_wrapper":"zA"};
    if(module.hot) {
      // 1713912565814
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  